import React, { memo } from "react";
import { useHistory } from 'react-router-dom';
import { Row, Col } from "react-bootstrap";
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './../../assets/css/style.css';
import './../home/home.css';


function CCSDMaster() {

  const history = useHistory();
  
  const routeChange = (path) => {
    history.push(path);
  }

  return (
    <div>

      <h2>CCSD</h2>
      <h4>Climate Change and Sustainable Development Master's Program</h4>

      {/* PRESENTATION CARD */}
      <div className="custom-card card-shadow">
        <div className="text-container">
          <h3>
            Graduates Career Prospects
          </h3>
          <hr />
          <p classname="p-reading-text">
            The CCSD offers interdisciplinary academic environment that promotes open critical inquiry of the scientific and socio-economic complexities of climate change. 
            Graduates of the master program will gain knowledge and learning experiences enabling them to offer a unique perspective and insight into a country already facing many of the potential impacts of climate change. 
            The CCSD prepares graduates to target jobs in the various emerging career paths in sustainable development and climate change.
            <br/>The climate change and sustainable development master degree prepares graduates to target jobs in the various emerging career paths in environmental economics and climate change including:
          </p>
          <div className="mt-3">
            <ul className="bullet-li">
              <li>
                <p className="p-reading-text">
                  Governmental agencies and municipalities develop plans for climate change mitigation and adaptation. 
                </p>
              </li>
            </ul>
                      
            <ul className="bullet-li">
              <li>
                <p className="p-reading-text">
                  Consultancy companies carrying out Environmental Impact Assessment, developing, implementing or monitoring climate change mitigation and adaptation projects. 
                </p>
              </li>
            </ul>  
            
            <ul className="bullet-li">
              <li>
                <p className="p-reading-text">
                  Climate change research, teaching and information dissemination. 
                </p>
              </li>
            </ul>  
            
            <ul className="bullet-li">
              <li>
                <p classname="p-reading-text">
                  NGOs and stakeholder organizations involved in climate change impacts assessment and sustainable development.
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="custom-card card-shadow">
        <div className="text-container">
          <h3>
            CCSD is a program that aims to provide learners with
          </h3>
          <hr />
          <ul className="bullet-li">
            <li>
              <p className="p-reading-text">
                A curriculum which provides a broad range of subjects to facilitate the development of abilities, pursuit of interests and promotion of career development.
              </p>
            </li>
          </ul>
                    
          <ul className="bullet-li">
            <li>
              <p className="p-reading-text">
                A course of study that develops the student intellectually and creatively by combining knowledge and skills for the multi-disciplinary role in effectively assessing climate change impacts, vulnerability and adaptation and their interrelationship with sustainability.
              </p>
            </li>
          </ul>  
          
          <ul className="bullet-li">
            <li>
              <p className="p-reading-text">
                A wide range of transferable skills and knowledge leading to employment opportunities in governmental and non-governmental organizations, and leading climate research and academic institutions.
              </p>
            </li>
          </ul>  
          
          <ul className="bullet-li">
            <li>
              <p classname="p-reading-text">
                Active and participative education through a variety of teaching and learning techniques. 
              </p>
            </li>
          </ul>

          <ul className="bullet-li">
            <li>
              <p classname="p-reading-text">
                An opportunity to acquire some of the skills necessary for lifelong learning.
              </p>
            </li>
          </ul>
        </div>
      </div>

      <div className="custom-card card-shadow">
        <div className="text-container">
          <h3>
            Admission
          </h3>
          <hr />
          <p classname="p-reading-text">
            Applicants must satisfy the University's general entry requirements to a master degree and should also demonstrate proficiency in English. Candidates may be interviewed as part of the selection process. 
            <br/>The program accepts graduates of the following faculties of Alexandria University or their equivalents from faculties of other universities: 
          </p>
          <Row className="mt-4">
            <Col xs={12} md={6}>
              <ul className="bullet-li">
                <li>
                  <p className="p-reading-text mb-3">
                    Medicine
                  </p>
                </li>
                <li>
                  <p className="p-reading-text mb-3">
                    Science
                  </p>
                </li>
                <li>
                  <p className="p-reading-text mb-3">
                    Engineering
                  </p>
                </li>
                <li>
                  <p className="p-reading-text mb-3">
                    Commerce (Economy)
                  </p>
                </li>
                <li>
                  <p className="p-reading-text mb-3">
                    Economic Studies and Political Science
                  </p>
                </li>
              </ul>
            </Col>
            <Col xs={12} md={6}>
              <ul className="bullet-li">
                <li>
                  <p className="p-reading-text mb-3">
                    Pharmacy
                  </p>
                </li>
                <li>
                  <p className="p-reading-text mb-3">
                    Agriculture
                  </p>
                </li>
                <li>
                  <p className="p-reading-text mb-3">
                    Fine Arts (Architecture)
                  </p>
                </li>
                <li>
                  <p className="p-reading-text mb-3">
                    Arts (Geography)
                  </p>
                </li>
              </ul>
            </Col>
          </Row>
        </div>
      </div>

      <div className="custom-card card-shadow">
        <div className="text-container">
          <h3>
            Course of Study
          </h3>
          <hr />
          <p classname="p-reading-text">
            The program runs for three academic years, starting in mid-September. Students enrolled in the program take 6 core courses (12 credit points), which are the foundation upon which the whole master degree is built and ensure a common knowledge base across disciplines. 
            Through the selection of various optional courses (12 credit points), students are able to tailor their studies towards own career interests. 
            Finally, students undertake a piece of original research leading to a master thesis with the support of an academic supervisor.
          </p>
        </div>
      </div>

      <div className="custom-card card-shadow">
        <div className="text-container">
          <h3>
            Courses
          </h3>
          <hr />
          <Row className="mt-4">
            <Col xs={12} md={6}>
              <h4 className="mb-4">
                Core Courses *
              </h4>
              <ul className="bullet-li">
                <li>
                  <p className="p-reading-text mb-3">
                    Fundamentals of environmental sciences
                  </p>
                </li>
                <li>
                  <p className="p-reading-text mb-3">
                    Sustainable development
                  </p>
                </li>
                <li>
                  <p className="p-reading-text mb-3">
                    Climate dynamics
                  </p>
                </li>
                <li>
                  <p className="p-reading-text mb-3">
                    Climate change mitigation, vulnerability and adaptation
                  </p>
                </li>
                <li>
                  <p className="p-reading-text mb-3">
                    Environmental economics and management
                  </p>
                </li>
                <li>
                  <p className="p-reading-text mb-3">
                    Statistical analysis in climate research
                  </p>
                </li>
              </ul>
            </Col>
            <Col xs={12} md={6}>
              <h4 className="mb-4">
                Optional Courses
              </h4>
              <ul className="bullet-li">
              <li>
                <p className="p-reading-text mb-3">
                  Economic valuation and climate change
                </p>
              </li>
              <li>
                <p className="p-reading-text mb-3">
                  Green economy
                </p>
              </li>
              <li>
                <p className="p-reading-text mb-3">
                  Geographical information systems applications in climate change
                </p>
              </li>
              <li>
                <p className="p-reading-text mb-3">
                  Remote sensing and environmental change
                </p>
              </li>
              <li>
                <p className="p-reading-text mb-3">
                  Environmental risk assessment and management
                </p>
              </li>
              <li>
                <p className="p-reading-text mb-3">
                  Community engagement and sustainable development
                </p>
              </li>
              <li>
                <p className="p-reading-text mb-3">
                  Climate change, biodiversity and ecosystems functions
                </p>
              </li>
              <li>
                <p className="p-reading-text mb-3">
                  Climate change and health
                </p>
              </li>
              <li>
                <p className="p-reading-text mb-3">
                  Urban Environment
                </p>
              </li>
              <li>
                <p className="p-reading-text mb-3">
                  Geopolitics of climate change
                </p>
              </li>
            </ul>
            </Col>
          </Row>
          <p className="mt-5 mb-3">
            * The program includes a non-credit course entitled “Scientific Research Skills” orients enrolled students to research design, critical reading and professional reporting.
          </p>
        </div>
      </div>

      {/* CONTACT US CARD */}
      <div className="custom-card card-shadow steel-texture-orange" style={{ flexDirection: 'column' }}>
        <div className="text-container">
          <h3>
            Want to Know More Before You Apply ?
          </h3>
          <p className="p-reading-text pt-2 pb-5">
            We’ve got everything you need to know!<br />Contact us for a closer look at our Master’s program and the application process.
          </p>
          <div style={{ display: "flex", justifyContent: "right" }}>
            <p className="important-title">
              <button className="btn-as-link-black" onClick={() => routeChange('contact-us')} >
                <b>Get in Touch</b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<FontAwesomeIcon icon={faPaperPlane} />
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default memo(CCSDMaster);